document.addEventListener('DOMContentLoaded', () => {
  const navLinks = [...document.querySelectorAll('.sizing-guide-page__nav-link[href^="#"]')];

  const getTarget = (hash) => {
    if (!hash || hash.charAt(0) !== '#') return null;
    return document.getElementById(decodeURIComponent(hash.slice(1)));
  };

  const getStickyOffset = () => {
    const header = document.querySelector('.shopify-section-group-header-group, .shopify-section-header, header');
    const pageNav = document.querySelector('.sizing-guide-page__nav-wrap');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const navHeight = pageNav ? pageNav.getBoundingClientRect().height : 0;

    return headerHeight + navHeight + 24;
  };

  const setActiveLink = (hash) => {
    navLinks.forEach((link) => {
      const isActive = link.getAttribute('href') === hash;

      link.classList.toggle('is-active', isActive);
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  };

  const scrollToTarget = (target, behavior = 'smooth') => {
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
    const safeTop = Math.max(0, top);

    if (behavior === 'smooth' && window.scrollY < 5 && safeTop > 5) {
      const root = document.documentElement;
      const previousScrollBehavior = root.style.scrollBehavior;

      root.style.scrollBehavior = 'auto';
      window.scrollTo({ top: 6, behavior: 'auto' });

      window.setTimeout(() => {
        root.style.scrollBehavior = previousScrollBehavior;
        window.scrollTo({ top: safeTop, behavior: 'smooth' });
      }, 0);

      return;
    }

    window.scrollTo({ top: safeTop, behavior });
  };

  const scrollToHash = (hash, behavior = 'smooth') => {
    const target = getTarget(hash);

    if (!target) return;

    const baseUrl = `${window.location.pathname}${window.location.search}`;

    if (window.location.hash === hash) {
      history.replaceState(null, '', baseUrl);
    }

    setActiveLink(hash);
    scrollToTarget(target, behavior);
    history.pushState(null, '', hash);
  };

  document.querySelectorAll('.sizing-guide-page__nav-link[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const hash = link.getAttribute('href');
      const target = getTarget(hash);

      if (!target) return;

      event.preventDefault();
      scrollToHash(hash);
    });
  });

  window.addEventListener('hashchange', () => {
    scrollToHash(window.location.hash);
  });

  if (window.location.hash) {
    const initialHash = window.location.hash;
    const target = getTarget(initialHash);

    if (target) {
      setActiveLink(initialHash);
      window.setTimeout(() => scrollToHash(initialHash), 120);
    }
  } else {
    setActiveLink('#measuring');
  }

  document.querySelectorAll('[data-sizing-guide-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-sizing-guide-track]');
    const slides = [...carousel.querySelectorAll('[data-sizing-guide-slide]')];
    const dots = [...carousel.querySelectorAll('[data-sizing-guide-dot]')];
    const previous = carousel.querySelector('[data-sizing-guide-prev]');
    const next = carousel.querySelector('[data-sizing-guide-next]');

    if (!track || slides.length === 0) return;

    const scrollToIndex = (index) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
    };

    const getIndex = () => {
      const width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    };

    const updateDots = () => {
      const activeIndex = getIndex();
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
        dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    };

    previous?.addEventListener('click', () => scrollToIndex(getIndex() - 1));
    next?.addEventListener('click', () => scrollToIndex(getIndex() + 1));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => scrollToIndex(index));
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateDots);
    }, { passive: true });

    updateDots();
  });
});
